import { CheckIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

import { getPromptIcon } from '@/Pages/Prompts/utils/Prompts.utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/Dropdown';

interface PromptsFilterDropdownProps {
  currentPromptFilter: 'all' | 'private' | 'public' | 'archived';
  setCurrentPromptFilter: (
    filter: 'all' | 'private' | 'public' | 'archived'
  ) => void;
}

export function PromptsFilterDropdown({
  currentPromptFilter,
  setCurrentPromptFilter,
}: PromptsFilterDropdownProps) {
  return (
    <div className="w-fit">
      <DropdownMenu>
        <DropdownMenuTrigger className="group my-auto rounded-lg border border-secondary py-1.5 pl-1 pr-3 outline-none hover:bg-secondary-hover">
          <div className="ml-2 flex flex-row gap-2">
            {['private', 'public'].includes(currentPromptFilter)
              ? getPromptIcon(currentPromptFilter === 'public')
              : null}
            <span className="capitalize">{currentPromptFilter} Prompts</span>
            <ChevronDownIcon className="my-auto h-5 w-5 cursor-pointer transition-all group-data-[state=open]:rotate-180" />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="max-h-[500px] overflow-auto"
          align="start"
        >
          <DropdownMenuItem
            className="flex flex-row items-center gap-2"
            onClick={() => {
              setCurrentPromptFilter('all');
            }}
          >
            All Prompts
            {currentPromptFilter === 'all' && (
              <CheckIcon className="my-auto h-4 w-4" />
            )}
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex flex-row items-center gap-2"
            onClick={() => {
              setCurrentPromptFilter('private');
            }}
          >
            {getPromptIcon(false)}
            Private
            {currentPromptFilter === 'private' && (
              <CheckIcon className="my-auto h-4 w-4" />
            )}
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex flex-row items-center gap-2"
            onClick={() => {
              setCurrentPromptFilter('public');
            }}
          >
            {getPromptIcon(true)}
            Public
            {currentPromptFilter === 'public' && (
              <CheckIcon className="my-auto h-4 w-4" />
            )}
          </DropdownMenuItem>
          <div className="border border-secondary" />
          <DropdownMenuItem
            className="flex flex-row items-center gap-2"
            onClick={() => {
              setCurrentPromptFilter('archived');
            }}
          >
            Archived
            {currentPromptFilter === 'archived' && (
              <CheckIcon className="my-auto h-4 w-4" />
            )}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
